export default function SnakeBoids() {
	return (
		<iframe
			src='/snake/index.html'
			title='Snake Eats Boids!'
			style={{ width: '100%', height: '100%', border: 'none' }}
		/>
	);
}
